/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface UploadBatchSummary
 */
export interface UploadBatchSummary {
    /**
     * 
     */
    batchId: string;
    /**
     * 
     */
    senderName: string | null;
    /**
     * 
     */
    createdAt: Date;
    /**
     * 
     */
    expectedCount: number;
    /**
     * 
     */
    doneCount: number;
    /**
     * 
     */
    failedCount: number;
    /**
     * 
     */
    finalizedAt: Date | null;
    /**
     * 
     */
    notifiedAt: Date | null;
    /**
     * 
     */
    coverUrl: string | null;
}

/**
 * Check if a given object implements the UploadBatchSummary interface.
 */
export function instanceOfUploadBatchSummary(value: object): value is UploadBatchSummary {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if ((!('senderName' in (value as Record<string, any>)) && !('sender_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['senderName'] === undefined && (value as Record<string, any>)['sender_name'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('expectedCount' in (value as Record<string, any>)) && !('expected_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['expectedCount'] === undefined && (value as Record<string, any>)['expected_count'] === undefined)) return false;
    if ((!('doneCount' in (value as Record<string, any>)) && !('done_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['doneCount'] === undefined && (value as Record<string, any>)['done_count'] === undefined)) return false;
    if ((!('failedCount' in (value as Record<string, any>)) && !('failed_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['failedCount'] === undefined && (value as Record<string, any>)['failed_count'] === undefined)) return false;
    if ((!('finalizedAt' in (value as Record<string, any>)) && !('finalized_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['finalizedAt'] === undefined && (value as Record<string, any>)['finalized_at'] === undefined)) return false;
    if ((!('notifiedAt' in (value as Record<string, any>)) && !('notified_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['notifiedAt'] === undefined && (value as Record<string, any>)['notified_at'] === undefined)) return false;
    if ((!('coverUrl' in (value as Record<string, any>)) && !('cover_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['coverUrl'] === undefined && (value as Record<string, any>)['cover_url'] === undefined)) return false;
    return true;
}

export function UploadBatchSummaryFromJSON(json: any): UploadBatchSummary {
    return UploadBatchSummaryFromJSONTyped(json, false);
}

export function UploadBatchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'senderName': json['sender_name'],
        'createdAt': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'expectedCount': json['expected_count'],
        'doneCount': json['done_count'],
        'failedCount': json['failed_count'],
        'finalizedAt': (json['finalized_at'] == null ? null : parseDateTime(json['finalized_at'])),
        'notifiedAt': (json['notified_at'] == null ? null : parseDateTime(json['notified_at'])),
        'coverUrl': json['cover_url'],
    };
}

export function UploadBatchSummaryToJSON(json: any): UploadBatchSummary {
    return UploadBatchSummaryToJSONTyped(json, false);
}

export function UploadBatchSummaryToJSONTyped(value?: UploadBatchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
        'sender_name': value['senderName'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'expected_count': value['expectedCount'],
        'done_count': value['doneCount'],
        'failed_count': value['failedCount'],
        'finalized_at': value['finalizedAt'] == null ? value['finalizedAt'] : serializeDateTime(value['finalizedAt']),
        'notified_at': value['notifiedAt'] == null ? value['notifiedAt'] : serializeDateTime(value['notifiedAt']),
        'cover_url': value['coverUrl'],
    };
}

